import { AbstractClient, CompositionClient } from "@/app/client";

export default class APIAuth extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  getGoogle = async (): Promise<any> => {
    let res = await this._fetch({
      url: `/auth/google`,
      method: "GET",
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
